export const transportOrdersSearchFieldMap: Record<string, string> = {
  product: "product_name",
  driver: "driver_name",
  driverManager: "driver_manager_email",
  trucks: "truck_number",
  trailers: "trailer_number",
  loadingLocation: "loading_address",
  loadingCity: "loading_city",
  loadingCountry: "loading_country",
  seller: "supplier_name",
  purchaseContract: "purchase_contract_number",
  buyer: "buyer_name",
  unloadingLocation: "unloading_address",
  unloadingCity: "unloading_city",
  unloadingCountry: "unloading_country",
  salesContract: "sales_contract_number",
  carrier: "transporter_name",
  number: "number",
};

export const forwardingSearchFieldMap: Record<string, string> = {
  trucks: "truck_number",
  trailers: "trailer_number",
  loadingLocation: "loading_address",
  loadingCity: "loading_city",
  loadingCountry: "loading_country",
  buyer: "client_name",
  unloadingLocation: "unloading_address",
  unloadingCity: "unloading_city",
  unloadingCountry: "unloading_country",
  carrier: "transporter_name",
  driver: "driver_name",
  driverManager: "driver_manager_email",
  purchaseInvoice: "purchase_invoice",
  number: "number",
};

export const deliveriesSearchFieldMap: Record<string, string> = {
  driver: "driver_name",
  driverManager: "driver_manager_email",
  loadingAddress: "loading_address",
  loadingCity: "loading_city",
  loadingCountry: "loading_country",
  unloadingAddress: "unloading_address",
  unloadingCity: "unloading_city",
  unloadingCountry: "unloading_country",
};

export const contractsSearchFieldMap: Record<string, string> = {
  broker: "broker",
  brokerInvoice: "broker_invoice",
  client: "client_name",
  location: "address",
  country: "country",
  city: "city",
  contractNumber: "contract_number",
  product: "product_name",
};

export const companiesSearchFieldMap: Record<string, string> = {
  name: "name",
  registryCode: "registry_code",
};
